export default __webpack_public_path__ + "static/media/LL.b4afbf47.svg";